"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormControlLabel = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var FormControlLabel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FormControlLabel, _Component);

  var _super = _createSuper(FormControlLabel);

  function FormControlLabel() {
    var _this;

    (0, _classCallCheck2.default)(this, FormControlLabel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var className = _this.props.className;
      return /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, (0, _extends2.default)({}, _this.props, {
        className: "prmbl-formControlLabel ".concat(className)
      }));
    });
    return _this;
  }

  return FormControlLabel;
}(_react.Component);

exports.FormControlLabel = FormControlLabel;
(0, _defineProperty2.default)(FormControlLabel, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * 	If `true`, the component appers selected.
   */
  checked: _propTypes.default.bool,

  /**
   * 	A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: _propTypes.default.element.isRequired,

  /**
   * If `true`, the control will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes.default.string.isRequired,

  /**
   * The name of the component.
   */
  name: _propTypes.default.string,

  /**
   * Callback fired when the state is changed.
   *
   * **Signature:**
   * `function(event: object, checked: boolean) => void`
   * *event*: The event source of the callback. You can pull out the new value by
   * accessing `event.target.value`.
   * *checked*: The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object
});
(0, _defineProperty2.default)(FormControlLabel, "defaultProps", {
  className: ""
});
var _default = FormControlLabel;
exports.default = _default;